
export default {
    'Gutter': {
        Mobile: 20,
        Tablet: 25,
        Laptop: 30,
        Desktop: 40
    },
    'Logo': {
        Mobile: 80,
        Tablet: 80,
        Laptop: 80,
        Desktop: 80
    },
    'MainRightSideWidth': {
        Mobile: "100%",
        Tablet: "50%",
        Laptop: `${(100 / 6) * 4}%`,
        Desktop: `${(100 / 9) * 6}%`,
    },
    'PositionMainRightSideWidth': {
        Mobile: "100%",
        Tablet: "50%",
        Laptop: `${(100 / 6) * 2}%`,
        Desktop: `${(100 / 9) * 3}%`,
    },
    'MainLeftSideWidth': {
        Mobile: "100%",
        Tablet: "50%",
        Laptop: `${(100 / 6) * 2}%`,
        Desktop: `${(100 / 9) * 3}%`,
    }
};


// WEBPACK FOOTER //
// ./src/constants/spacing.ts